import { useSelector } from "react-redux";
import PrimoSubscription from "../shared/PrimoSubscription";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Continue from "../shared/PrimoSubscriptionModal/Continue";

export default function Join() {
  const current_user = useSelector((a) => a.current_user);
  const history = useHistory();

  const [showDistributionModul, setShowDistributionModul] = useState(false);
  const [showContinue, setShowContinue] = useState(false);

  useEffect(() => {
    if (!current_user) {
      window.location.href = "/login";
    }
    if (current_user?.is_subscribed_to_primo) {
      // window.location.href = "https://distro.hudlmusic.com";
    }
  }, [current_user]);

  const onContinue = () => {
    setShowContinue(false);
    // setShowDistributionModul(true);
    console.log("albert go continue");
    history.push("/ai-music-manager");
  };

  const handleClose = () => {
    setShowContinue(false);
    setShowDistributionModul(false);
  };

  const onCheckoutDone = () => {
    console.log("asdfasdfaadsf");
    setShowContinue(true);
  };
  return (
    <>
    {console.log("Rendering Component:", { showContinue }) || null}
      {true && (
        <div className="p-4" style={{ textAlign: "center" }}>
          {showContinue ? (
            <Continue onContinue={onContinue} />
          ) : (
            <PrimoSubscription handleClose={handleClose} onCheckoutDone={onCheckoutDone} showDistributionModul={false} />
          )}
        </div>
      )}
    </>
  );
}
